import { pathJoin } from 'src/reducers/routing/utils'

export const createCrmPortalViewRoutesMap = (prefix: string) => ({
  general: pathJoin(prefix)('general').chain,
  customisation: pathJoin(prefix)('customisation').chain,
})
